import * as React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./App.css";

import Home from "./pages/Home";
import About from "./pages/About";
import Properties from "./pages/Properties";
import Team from "./pages/Team";
//import News from './pages/News';
import Careers from "./pages/Careers";
import Partners from "./pages/Partners";
import Contact from "./pages/Contact";
import Green from "./pages/Green";
import QrLanding from "./pages/QrLanding";

export interface PeopleResponse {
  People: PeopleEntity[];
}

export interface PeopleEntity {
  Name: string;
  Title: string;
  Description: string;
  ImageSprite: string;
  ImageZoom: string;
}

interface IState {
  featuredProperties: Array<{
    name: string;
    location: string;
    units: number;
    description: string;
    thumbnail: string;
    picture: string;
    sortOrder: null | number;
  }>;
  totalUnits: null | number;
  totalProperties: null | number;
  totalStates: null | number;
  totalInvested: null | number;
  PeopleEntities?: PeopleEntity[] | null;
}

function api<T>(url: string): Promise<T> {
  return fetch(url).then((response) => {
    if (!response.ok) {
      const errorMessage = "Error loading data from " + url + ": " + response.status + ": " + response.statusText;
      console.log(errorMessage);
      return Promise.reject(errorMessage);
    }
    return response.json().then((data) => data as T);
  });
}

/**
 * Randomize array element order in-place.
 * Using Durstenfeld shuffle algorithm.
 */
function shuffleArray(array: any[]) {
  for (var i = array.length - 1; i > 0; i--) {
    var j = Math.floor(Math.random() * (i + 1));
    var temp = array[i];
    array[i] = array[j];
    array[j] = temp;
  }
}

class App extends React.Component<{}, IState> {
  state: IState = {
    featuredProperties: [],
    totalUnits: null,
    totalProperties: null,
    totalStates: null,
    totalInvested: null,
    PeopleEntities: null,
  };
  componentDidMount() {
    api<PeopleResponse>("https://acd1.blob.core.windows.net/employeephotos/index.json").then((data) => {
      var people = data.People;
      shuffleArray(people);
      this.setState({ PeopleEntities: people });
    });
    api<IState>("https://www.acdmail.com/propfacts/api/ReactSiteInfo").then((data) => {
      var properties = data.featuredProperties;
      properties.forEach((property) => {
        if (property.sortOrder === null) {
          property.sortOrder = Math.floor(Math.random() * (2000 - 1000) + 1000);
        }
      });
      properties = properties.slice().sort((a, b) => (a.sortOrder ?? 0) - (b.sortOrder ?? 0));
      data.featuredProperties = properties;
      this.setState(data);
    });
  }
  render() {
    return (
      <BrowserRouter>
        <div className="App">
          <Routes>
            <Route path="/about" element={<About />} />
            <Route
              path="/properties"
              element={
                <Properties
                  properties={this.state.featuredProperties}
                  totalProperties={this.state.totalProperties}
                  totalStates={this.state.totalStates}
                />
              }
            />
            <Route path="/team" element={<Team peopleEntities={this.state.PeopleEntities} />} />
            <Route path="/careers" element={<Careers />} />
            <Route path="/partners" element={<Partners />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/green" element={<Green />} />
            <Route path="/qr/:code" element={<QrLanding />} />
            <Route
              path="/"
              element={
                <Home
                  totalUnits={this.state.totalUnits}
                  totalProperties={this.state.totalProperties}
                  totalStates={this.state.totalStates}
                  totalInvested={this.state.totalInvested}
                />
              }
            />
          </Routes>
        </div>
      </BrowserRouter>
    );
  }
}

export default App;
